// semeia-disable-reexport
export function computeDas28Vs({
  nad,
  nag,
  sedRate,
  patientFeeling
}: Record<string, number>): number {
  const das28 =
    0.56 * Math.sqrt(nad) +
    0.28 * Math.sqrt(nag) +
    0.7 * Math.log(sedRate) +
    0.014 * (patientFeeling * 10);
  return Math.round(das28 * 100) / 100; //get 2 significant numbers
}

export function computeDas28Crp({
  nad,
  nag,
  crp,
  patientFeeling
}: Record<string, number>): number {
  const das28 =
    0.56 * Math.sqrt(nad) +
    0.28 * Math.sqrt(nag) +
    0.36 * Math.log(crp + 1) +
    0.014 * (patientFeeling * 10) +
    0.96;
  return Math.round(das28 * 100) / 100; //get 2 significant numbers
}

/**
 * CRP unit is mg/dL instead of mg/L
 */
export function computeDas28Sdai({
  nad,
  nag,
  crp,
  patientFeeling,
  medicFeeling
}: Record<string, number>): number {
  const das28 = nad + nag + crp + patientFeeling + medicFeeling;
  return Math.round(das28 * 100) / 100; //get 2 significant numbers
}

export function computeDas28Cdai({
  nad,
  nag,
  patientFeeling,
  medicFeeling
}: Record<string, number>): number {
  const das28 = nad + nag + patientFeeling + medicFeeling;
  return Math.round(das28 * 100) / 100; //get 2 significant numbers
}
